import React from 'react'

const Button = (props) => {
    return (
        <button name={props.name} className="button button--magenta button--big">{props.title}</button>
    )
}

export default Button